package link.erpango.quip.domain.entities

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
enum class VehicleType(val code: String) {
    @SerialName("car")
    CAR("car"),
    @SerialName("motorcycle")
    MOTORCYCLE("motorcycle"),
    @SerialName("truck")
    TRUCK("truck"),
    @SerialName("van")
    VAN("van"),
    @SerialName("bus")
    BUS("bus"),
    @SerialName("other")
    OTHER("other");

    companion object {
        fun fromCode(code: String): VehicleType {
            return entries.find { it.code == code } ?: CAR
        }
    }
}

@Serializable
data class DVehicle(
    val vin: String,
    val plate: String,
    val brand: String,
    val model: String,
    @SerialName("vehicle_type")
    val vehicleType: VehicleType,
    val year: Int,
    val color: String,
    val owner: String,
    @SerialName("engine_oil")
    val engineOil: String = "",
    @SerialName("front_tire_size")
    val frontTireSize: String = "",
    @SerialName("rear_tire_size")
    val rearTireSize: String = "",
    @SerialName("front_tire_pressure_below_160")
    val frontTirePressureBelow160: Double = 0.0,
    @SerialName("rear_tire_pressure_below_160")
    val rearTirePressureBelow160: Double = 0.0,
    @SerialName("front_tire_pressure_above_160")
    val frontTirePressureAbove160: Double = 0.0,
    @SerialName("rear_tire_pressure_above_160")
    val rearTirePressureAbove160: Double = 0.0,
    @SerialName("recommended_fuel")
    val recommendedFuel: String = "",
    @SerialName("engine_details")
    val engineDetails: String = "",
    @SerialName("cylinder_count")
    val cylinderCount: Int = 0,
    @SerialName("front_bulb_type")
    val frontBulbType: String = "",
    @SerialName("rear_bulb_type")
    val rearBulbType: String = "",
    @SerialName("battery_specs")
    val batterySpecs: String = "",
    @SerialName("coolant_type")
    val coolantType: String = "",
    @SerialName("next_revision_date")
    val nextRevisionDate: Long? = null,
    @SerialName("next_itv_date")
    val nextItvDate: Long? = null,
    @SerialName("first_registration_date")
    val firstRegistrationDate: Long? = null,
    val signature: String? = null,
    var maintenances: List<DMaintenance> = emptyList()
) {
    fun getBrandModelAndYear(): String {
        return "${brand} ${model} (${year})"
    }
}
